import { render } from "./HealthTracking.vue?vue&type=template&id=1b919ef5&scoped=true"
import script from "./HealthTracking.vue?vue&type=script&lang=js"
export * from "./HealthTracking.vue?vue&type=script&lang=js"

import "./HealthTracking.vue?vue&type=style&index=0&id=1b919ef5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b919ef5"]])

export default __exports__